export default __webpack_public_path__ + "static/media/resume.42c439cb.png";